import { AxiosResponse } from 'axios';
import { userBalanceDetail, userBalanceList } from '@/api/userBalance';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types/service';
import { IUserBalanceApiListResponse, IUserBalanceFilters } from '@/types/userBalance';

export const userBalanceService = {
    async list(params: IListParams<IUserBalanceFilters>): Promise<AxiosResponse<IUserBalanceApiListResponse>> {
        try {
            return await baseListService<IUserBalanceApiListResponse>(userBalanceList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('User Balance API Error:', e);
            throw new AppError('Unable to load user balance list, request error', { cause: e });
        }
    },

    async detail(params: IListParams<IUserBalanceFilters>): Promise<AxiosResponse<IUserBalanceApiListResponse>> {
        try {
            return await baseListService<IUserBalanceApiListResponse>(userBalanceDetail, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('User Balance Detail API Error:', e);
            throw new AppError('Unable to load user balance detail, request error', { cause: e });
        }
    },
};
